import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest, Subject, takeUntil } from 'rxjs';
import { ModulesWithAvailableActivityList } from 'src/app/business/available-activities/available-activities.component';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';
import { ExternalSettings } from '../../services/external-settings/external-settings.interface';
import { ExternalSettingsService } from '../../services/external-settings/external-settings.service';
import { ResponsiveDesignService } from '../../services/responsive-design/responsive-design.service';
import { PlatformService } from 'src/app/system/utility/platform.service';
import { NavigationService } from 'src/app/system/utility/navigation.service';
import { PermittedActivityService } from '../../services/permitted-activity/permitted-activity.service';
import { PAMenuMobile } from '../../services/permitted-activity/pa-menu-meta';

@Component({
    selector: 'app-bottom-bar-nav',
    templateUrl: './bottom-bar-nav.component.html',
    styleUrls: ['./bottom-bar-nav.component.less'],
    standalone: false
})
export class BottomBarNavComponent implements OnInit, OnDestroy {

  PlatformService: any = PlatformService;
  UIUtilityService: any = UIUtilityService;
  protected externalSettings!: ExternalSettings;
  private destroy$ = new Subject<void>();

  menu!: PAMenuMobile;
  itemClass: string = 'w-25';
  protected itemList: BottomBarNavItem[] = [];

  constructor(
    private router: Router,
    private srvES: ExternalSettingsService,
    private permitted: PermittedActivityService,
    private srvRpDesign: ResponsiveDesignService,
  ) { }

  ngOnInit(): void {
    combineLatest([
      this.srvES.externalSettings$,
      this.permitted.menuMobileApp$,
      this.permitted.menuMobileView$
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([externalSettings, menuMobileApp, menuMobileView]) => {
        this.externalSettings = externalSettings;
        this.menu = PlatformService.isMobile() ? menuMobileApp! : menuMobileView!;
        if (menuMobileApp || menuMobileView) this.initItemList();
      })
  }

  initItemList() {
    this.itemList = [];
    let itemMenu: BottomBarNavItem = {
      name: 'menu',
      imgSrc: 'assets/images/icons/nav_menu.png',
      imgAlt: 'Icon Menu',
      label: 'LABEL_MENU',
      action: this.onSidebarClick.bind(this),
    }
    let itemHome: BottomBarNavItem = {
      name: 'home',
      imgSrc: 'assets/images/icons/nav_home.png',
      imgAlt: 'Icon Home',
      label: 'LABEL_HOME',
      action: this.onDashboardClick.bind(this),
    }
    let itemTransfer: BottomBarNavItem = {
      name: 'transfer',
      imgSrc: 'assets/images/icons/nav_transfers.png',
      imgAlt: 'Icon Transfers',
      label: 'LABEL_TRANSFERS',
      action: this.onTransferClick.bind(this),
    }
    let itemPayment: BottomBarNavItem = {
      name: 'payment',
      imgSrc: 'assets/images/icons/nav_payments.png',
      imgAlt: 'Icon Payments',
      label: 'LABEL_PAYMENTS',
      action: this.onPaymentClick.bind(this),
    }
    this.itemList.push(itemMenu, itemHome);
    let transferList = this.menu.getSubMenu('internalTransfers');
    if (transferList.length > 0) this.itemList.push(itemTransfer);
    let paymentList = this.menu.getSubMenu('payments');
    if (paymentList.length > 0) this.itemList.push(itemPayment);

    if (this.itemList.length == 2) this.itemClass = 'w-50';
    if (this.itemList.length == 3) this.itemClass = 'width-33';
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  protected onSidebarClick() {
    this.toggleSidebar(true);
  }

  protected onDashboardClick() {
    this.toggleSidebar(false);
    NavigationService.gotoDashboard(this.router);
  }

  protected onTransferClick() {
    this.toggleSidebar(false);
    NavigationService.gotoActivityPage(this.router, ModulesWithAvailableActivityList.INTERNAL_TRANSFERS);
  }

  protected onPaymentClick() {
    this.toggleSidebar(false);
    NavigationService.gotoActivityPage(this.router, ModulesWithAvailableActivityList.PAYMENTS);
  }

  private toggleSidebar(isShowSidebarNav: boolean) {
    this.srvRpDesign.setSidebarNav(isShowSidebarNav);
  }

}

export interface BottomBarNavItem {
  name: string;
  imgSrc: string;
  imgAlt: string;
  label: string;
  action: any;
}